/*  FYP SEARCH FIELDS SHIM  ·  v1.1  ·  25 Jul 2026 (v1.0) / 12 Aug 2026 (v1.1)
 *  ---------------------------------------------------------------------------
 *  WHY THIS FILE EXISTS
 *  Shopify's predictive-search endpoints search only four product fields by
 *  default: title, product_type, variants.title, vendor. Tags and descriptions
 *  are opt-in via `resources[options][fields]`. Impact's compiled
 *  <predictive-search> element (assets/theme.js) never sends that parameter, so
 *  no product tag is visible to the search drawer.
 *
 *  WHY A SHIM RATHER THAN AN EDIT TO theme.js
 *  theme.js is a 237 KB minified vendor bundle. Any Impact update overwrites it
 *  and silently takes the fix with it. This file keys off the URL shape of
 *  Shopify's own public search endpoints, which is a documented API contract and
 *  far more stable than a minified private method name. It survives theme
 *  updates untouched.
 *
 *  WHAT IT DOES
 *  Wraps window.fetch and appends `resources[options][fields]` to - and only to
 *  - the two requests Impact's predictive-search element makes:
 *    1. <root>search/suggest?...            (predictive endpoint)
 *    2. <root>search?...&resources[limit_scope]=each   (Impact's fallback path
 *       used when the market/locale has no predictive API)
 *  Everything else - including ordinary /search results-page and facet requests,
 *  which also hit /search - is passed through untouched.
 *
 *  Impact calls a cachedFetch() wrapper that invokes the global fetch at call
 *  time (verified in theme.js), so this patch is picked up regardless of load
 *  order. Its cache key is the pre-rewrite URL, so caching stays consistent.
 *
 *  CONFIGURATION
 *  The field list comes from the data-fyp-search-fields attribute rendered by
 *  sections/search-drawer.liquid (a theme-editor setting), falling back to the
 *  constant below. Nothing here hard-codes a section id - the section id is
 *  still supplied by Impact from the element's own section-id attribute.
 *
 *  v1.1 — SEARCH-GUIDE CLICK INSTRUMENTATION (12 Aug 2026)
 *  A delegated click listener emits fyp_search_guide_click whenever an element
 *  carrying [data-sg-action] is clicked — the intent-card CTAs, pills, products,
 *  guides and tool links. Delegation is the point: the predictive drawer's card
 *  arrives as injected HTML (section rendering API) where inline scripts never
 *  execute, so the listener must already exist on the page. Context (query,
 *  intent, zero, surface) is read from the closest .fyp-sg host's data
 *  attributes. Payload contains no PII. Sinks mirror the Finder engine:
 *  dataLayer + DOM CustomEvent + Shopify.analytics.
 *
 *  ROLLBACK
 *  Remove the <script> tag from sections/search-drawer.liquid, or delete this
 *  file. Behaviour returns to Shopify defaults immediately; no data is changed.
 */
(function () {
  'use strict';

  if (window.__fypSearchFieldsPatched) return;
  window.__fypSearchFieldsPatched = true;

  // Deliberately does NOT include `body`. Description text is broad marketing
  // language and pollutes results; enabling it is a separate, evidenced decision.
  var DEFAULT_FIELDS = 'title,product_type,variants.title,vendor,tag';
  var PARAM = 'resources[options][fields]';

  function configuredFields() {
    var el = document.querySelector('predictive-search[data-fyp-search-fields]');
    var value = el && el.getAttribute('data-fyp-search-fields');
    return value && value.trim() ? value.trim() : DEFAULT_FIELDS;
  }

  // True only for the predictive-search element's own requests.
  function isPredictiveRequest(url) {
    var path = url.pathname.replace(/\/+$/, '');
    if (!url.searchParams.has('q')) return false;
    if (/\/search\/suggest$/.test(path)) return true;
    // Impact's fallback path hits /search but always carries limit_scope=each,
    // which ordinary results-page and facet requests never do.
    return /\/search$/.test(path) && url.searchParams.get('resources[limit_scope]') === 'each';
  }

  function rewrite(rawUrl) {
    try {
      var url = new URL(rawUrl, window.location.origin);
      if (!isPredictiveRequest(url)) return rawUrl;
      if (url.searchParams.has(PARAM)) return rawUrl; // never override an explicit value
      url.searchParams.set(PARAM, configuredFields());
      return url.toString();
    } catch (e) {
      return rawUrl; // on any doubt, leave the request exactly as it was
    }
  }

  var nativeFetch = window.fetch.bind(window);

  window.fetch = function (input, init) {
    try {
      if (typeof input === 'string') {
        input = rewrite(input);
      } else if (input instanceof URL) {
        input = rewrite(input.toString());
      } else if (typeof Request !== 'undefined' && input instanceof Request) {
        var next = rewrite(input.url);
        if (next !== input.url) input = new Request(next, input);
      }
    } catch (e) {
      /* fall through with the original input */
    }
    return nativeFetch(input, init);
  };

  /* ----- v1.1: search-guide click instrumentation (no PII) ----- */
  document.addEventListener('click', function (ev) {
    try {
      var t = ev.target;
      if (!t || !t.closest) return;
      var a = t.closest('[data-sg-action]');
      if (!a) return;
      var host = a.closest('.fyp-sg');
      var d = {
        action: a.getAttribute('data-sg-action') || '',
        intent: host ? (host.getAttribute('data-sg-intent') || 'none') : 'none',
        query: host ? (host.getAttribute('data-sg-query') || '') : '',
        zero_result: host ? host.getAttribute('data-sg-zero') === 'true' : false,
        surface: (host && host.getAttribute('data-sg-surface')) ? host.getAttribute('data-sg-surface') : 'page',
        href: a.getAttribute('href') || ''
      };
      window.dataLayer = window.dataLayer || [];
      var p = { event: 'fyp_search_guide_click' };
      for (var k in d) { if (Object.prototype.hasOwnProperty.call(d, k)) p[k] = d[k]; }
      window.dataLayer.push(p);
      document.dispatchEvent(new CustomEvent('fyp_search_guide_click', { detail: d, bubbles: true }));
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('fyp_search_guide_click', d);
    } catch (e) {}
  }, true);
})();
